import React from "react";
import useAddDimension from "../hooks/useAddDimension";
import AddDimension from "../components/AddDimension";

const AddDimensionInterface = React.forwardRef((props, ref) => {
  const {
    open,
    optionalDimension,
    dimension,
    multipleChoice,
    maxChoices,
    paidSupplement,
    amountSupplement,
    type,
    submitting,
    openSnack,
    snackbarMessage,
    editingDimension,
    copyMode,
    selectedItemId,
    selectedDimensionType,
    items,
    filteredAndSortedItems,
    availableDimensions,
    searchTerm,
    onOptionalDimensionChange,
    onDimensionChange,
    onMultipleChoiceChange,
    onMaxChoicesChange,
    onPaidSupplementChange,
    onAmountSupplementChange,
    onTypeChange,
    openDialog,
    openDialogWithDimension,
    closeDialog,
    onSave,
    onCancel,
    onCloseSnack,
    onCopyModeChange,
    onItemSelect,
    onDimensionSelect,
    onSearchChange,
  } = useAddDimension(props);

  // Expose openDialogWithDimension to parent via ref
  React.useImperativeHandle(ref, () => ({
    openDialogWithDimension,
  }));

  return (
    <AddDimension
      open={open}
      optionalDimension={optionalDimension}
      dimension={dimension}
      multipleChoice={multipleChoice}
      maxChoices={maxChoices}
      paidSupplement={paidSupplement}
      amountSupplement={amountSupplement}
      type={type}
      submitting={submitting}
      openSnack={openSnack}
      snackbarMessage={snackbarMessage}
      editingDimension={editingDimension}
      copyMode={copyMode}
      selectedItemId={selectedItemId}
      selectedDimensionType={selectedDimensionType}
      items={items}
      filteredAndSortedItems={filteredAndSortedItems}
      availableDimensions={availableDimensions}
      searchTerm={searchTerm}
      onOptionalDimensionChange={onOptionalDimensionChange}
      onDimensionChange={onDimensionChange}
      onMultipleChoiceChange={onMultipleChoiceChange}
      onMaxChoicesChange={onMaxChoicesChange}
      onPaidSupplementChange={onPaidSupplementChange}
      onAmountSupplementChange={onAmountSupplementChange}
      onTypeChange={onTypeChange}
      openDialog={openDialog}
      openDialogWithDimension={openDialogWithDimension}
      closeDialog={closeDialog}
      onSave={onSave}
      onCancel={onCancel}
      onCloseSnack={onCloseSnack}
      onCopyModeChange={onCopyModeChange}
      onItemSelect={onItemSelect}
      onDimensionSelect={onDimensionSelect}
      onSearchChange={onSearchChange}
    ></AddDimension>
  );
});

export default AddDimensionInterface;
